import { useCallback } from 'react';
import { replace } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { FLAG_UPDATE_PAYMENT_METHOD } from 'config';
import { useActions } from 'lib/hooks';
import { getUpdatePaymentMethodPageLink } from 'lib/links';
import { CREDIT_CARD_EXPIRED_ACTION_TYPE } from 'lib/gaTracking/crossPageEvents';
import * as track from 'lib/gaTracking/crossPageEvents';
import { updatePaymentMethodModalProps, contactUsModalProps } from '../ExpiredCardModal';

const { UPDATE_PAYMENT_METHOD, CONTACT_US } = CREDIT_CARD_EXPIRED_ACTION_TYPE;

export const useExpiredCardModal = ({ bookingId }: { bookingId: string }) => {
  const actions = useActions();
  const dispatch = useDispatch();
  const modalProps = FLAG_UPDATE_PAYMENT_METHOD ? updatePaymentMethodModalProps : contactUsModalProps;
  const modalType = FLAG_UPDATE_PAYMENT_METHOD ? UPDATE_PAYMENT_METHOD : CONTACT_US;

  return useCallback(() => {
    track.expiredCreditCardModalOpened(modalType);
    actions.modal.setupModal({
      ...modalProps,
      isOpen: true,
      onClose: ({ actionButtonClicked }) => {
        track.expiredCreditCardModalClosed(modalType, actionButtonClicked);
        if (FLAG_UPDATE_PAYMENT_METHOD && actionButtonClicked) {
          dispatch(replace(getUpdatePaymentMethodPageLink(bookingId)));
        }
      },
    });
  }, [actions.modal, bookingId, dispatch, modalProps, modalType]);
};
